import React, { useState, useRef } from "react";
import { Box, TextField, IconButton, Tooltip } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { rowsFromCsvOrXlsx } from "../../utils/fileHelpers";

const MAX_FILE_SIZE_MB = 100;
const SUPPORTED_TYPES = [".csv", ".xlsx", ".parquet"];

export default function ChatInput({
  onSend,
  onUpload,
  onFocus,
  togglePreview,
  isPreviewOpen,
  rows,

}) {
  const [value, setValue] = useState("");
  const [fileError, setFileError] = useState(""); // for tooltip message
  const inputRef = useRef();

  const submit = () => {
    if (!value.trim()) return;
    onSend?.(value.trim());
    setValue("");
  };

  const handleFiles = async (files) => {
    const file = files[0];
    if (!file) return;

    // Reset previous error
    setFileError("");

    // Validate file type
    const ext = `.${file.name.split(".").pop().toLowerCase()}`;
    if (!SUPPORTED_TYPES.includes(ext)) {
      setFileError("Unsupported file type. Only CSV, XLSX, Parquet allowed.");
      return;
    }

    // Validate file size
    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      setFileError(
        `File too large. Maximum allowed size is ${MAX_FILE_SIZE_MB} MB.`
      );
      return;
    }

    onFocus?.(); // hide welcome

    try {
      // const parsedRows = await rowsFromCsvOrXlsx(file);
      onUpload?.([], file.name, file);
      
    } catch (e) {
      setFileError("Failed to parse file. Please try a different file format.");
    }
  };

  const isPreviewAvailable = rows && rows.length > 0;

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "flex-end", mb: 2, p: 1,  }}>
      <input
        ref={inputRef}
        type="file"
        style={{ display: "none" }}
        accept={SUPPORTED_TYPES.join(",")}
        onChange={(e) => handleFiles(e.target.files)}
      />

      <Tooltip title={fileError || "Upload CSV, XLSX or Parquet (max 100MB)"}>
        <IconButton
          sx={{ p: 1.5, borderRadius: "50%", bgcolor: "action.hover" }}
          onClick={() => {
            onFocus?.();
            inputRef.current.click();
          }}
        >
          <AddIcon />
        </IconButton>
      </Tooltip>

      <TextField
        fullWidth
        placeholder="Upload a file & ask: show table, visualize column..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onFocus={() => onFocus?.()}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            submit();
          }
        }}
        multiline
        maxRows={4}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "24px",
            "&:hover fieldset": { borderColor: "#0b74ff" },
            "&.Mui-focused fieldset": { borderColor: "#0b74ff" },
          },
        }}
      />

      <IconButton
        color="primary"
        onClick={submit}
        disabled={!value.trim()}
        sx={{
          p: 1.5,
          borderRadius: "50%",
          bgcolor: !value.trim() ? "action.disabledBackground" : "#0b74ff",
          color: "#fff",
          "&:hover": {
            bgcolor: !value.trim() ? "action.disabledBackground" : "#0866d9",
          },
        }}
      >
        <SendIcon />
      </IconButton>

      {/* {isPreviewAvailable && (
        <Tooltip title={isPreviewOpen ? "Close Preview" : "Open Preview"}>
          <IconButton
            color={isPreviewOpen ? "secondary" : "default"}
            onClick={() => {
              onFocus?.();
              togglePreview();
            }}
            sx={{ p: 1.5, borderRadius: "50%" }}
          >
            {isPreviewOpen ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </IconButton>
        </Tooltip>
      )} */}
    </Box>
  );
}
